import { createContext } from 'react';

/** Context follows More/Share portals without reading DOM refs during render. */
export const ActionBarAnalyticsScope = createContext<string | undefined>(undefined);
